class Points {

    constructor() {
        this.points = document.querySelectorAll('[data-point]');
        this.pointActiveClass = 'point--active';
        this.handlePoints();
    }

    handlePoints() {
        for (let i = 0; i < this.points.length; i++) {
            let point = this.points[i];
            point.addEventListener('mouseenter', () => {
                let target = point.dataset.point,
                    objects = document.querySelectorAll(`[data-point="${target}"]`);
                for (let j = 0; j < objects.length; j++) {
                    let targetObject = objects[j];
                    targetObject.classList.add(this.pointActiveClass);
                }
            });
            point.addEventListener('mouseleave', () => {
                let target = point.dataset.point,
                    objects = document.querySelectorAll(`[data-point="${target}"]`);
                for (let j = 0; j < objects.length; j++) {
                    let targetObject = objects[j];
                    targetObject.classList.remove(this.pointActiveClass);
                }
            });
        }
    }


} export default Points;
